import React from 'react';
import { useIntl } from 'react-intl';
import LoadingCoffeeCup from '@starbucks-web/pattern-library/lib/components/loading-coffee-cup';
import messages from './messages';

const ContentCrateLoading = () => {
  const { formatMessage } = useIntl();

  return (
    <LoadingCoffeeCup
      className="my9"
      data-e2e="coffee-loader"
      title={formatMessage(messages.contentCrateLoading)}
    />
  );
};

export default ContentCrateLoading;
